import { getGoldSetQueueUrl } from '~/entities/gold-set'
import { Button, OptiWalkingWithCheckmark, Text } from '~/shared/ui'

export function AllDone({
  pass,
  onShowLastDocument,
}: {
  pass: number
  onShowLastDocument: () => void
}) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center">
      <OptiWalkingWithCheckmark width="96" />
      <Text appearance="H6">All done</Text>
      <Text
        className="text-text-secondary"
        appearance="BODY2"
      >
        {`No document is left to do in pass ${pass}. Thank you!`}
      </Text>
      <div className="flex gap-2">
        <Button onClick={onShowLastDocument}>Back to the last document</Button>
        <Button
          raised
          to={getGoldSetQueueUrl(pass)}
        >
          Back to the queue
        </Button>
      </div>
    </div>
  )
}
